import { DistanceUnit } from "@keita/lanepatrol-sdk";

export const compressUUID = (uuid: string, fix: number = 4) => {
  if (uuid === "*") return uuid;

  return `${uuid.slice(0, fix)}...${uuid.slice(36 - fix, 36)}`;
};

export const defaultTimeFormatOptions: Intl.DateTimeFormatOptions = {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
};

export const defaultDateFormatOptions: Intl.DateTimeFormatOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

export const formatDateString = (
  utcDate: string,
  options?: Intl.DateTimeFormatOptions
) => {
  return new Date(utcDate).toLocaleString(undefined, options);
};

export const formatDistanceByUnit = (meters: number, unit: DistanceUnit) => {
  const km = meters / 1000;

  if (unit === DistanceUnit.Imperial) {
    return (km * 0.621371).toFixed(2);
  }

  return km.toFixed(2);
};
